import { all, call, put, takeLatest, select } from "redux-saga/effects";
import set from "lodash/set";

import { cloneDeep } from "../../utils/cloneDeep";

import {
  RECEIVE_APPCONFIG,
  receiveAppConfigSuccess,
  receiveAppConfigFail,
  UPDATE_PROSPECT,
  UPDATE_ROPROSPECT,
  setConfig,
  updateProspect,
  updateRoProspect,
  UPDATE_VIEW_ID,
  saveSignatoryModel,
  saveRoSignatoryModel,
  UPDATE_CONSENT_EMAIL_TRIGGER_TIME,
  RECEIVE_DATALIST_SEARCH,
  receiveDatalistSearchSuccess,
  receiveDatalistSearchFail
} from "../actions/appConfig";
import { sendProspectToAPI, sendProspectToAPISuccess } from "../actions/sendProspectToAPI";
import { config, getDatalistSearch } from "../../api/apiClient";
import { UAE_CODE, UAE, UAE_CURRENCY, AUTO, financeNames } from "../../constants";
import {
  getIsIslamicBanking,
  getFinanceType,
  getProspect,
  getRoProspect,
  getLeadSource,
  getRoCode,
  getAuthorizationHeader
} from "../selectors/appConfig";
import { log } from "../../utils/loggger";

export function* receiveAppConfigSaga() {
  try {
    const financeType = yield select(getFinanceType);
    let response = null;

    if (financeType) {
      response = yield call(config.load, financeType);
    } else {
      /* istanbul ignore if  */
      if (process.env.NODE_ENV === "development") {
        response = yield call(config.load, financeNames.businessFinance);
      } else {
        response = yield call(config.load, null);
      }
    }

    const newConfig = response.data;
    const signatoryModel = newConfig.prospect
      ? cloneDeep(newConfig.prospect.signatoryInfo[0])
      : null;
    const roSignatoryModel = newConfig.prospect
      ? cloneDeep(newConfig.roProspect.signatoryInfo[0])
      : null;

    if (newConfig.prospect) {
      newConfig.prospect.signatoryInfo = [];
      newConfig.prospect.accountInfo[0].accountCurrency = UAE_CURRENCY;
      //newConfig.prospect.financeInfo[0].accountCurrency = UAE_CURRENCY;

      if (!newConfig.prospect.applicantInfo.countryCode) {
        newConfig.prospect.applicantInfo.countryCode = UAE_CODE;
      }
      newConfig.prospect.applicantInfo.LeadSource = yield select(getLeadSource);
      newConfig.prospect.applicantInfo.roCode = yield select(getRoCode);
      newConfig.prospect.applicationInfo.financeType = yield select(getFinanceType);
      newConfig.prospect.applicationInfo.islamicBanking = yield select(getIsIslamicBanking);
      newConfig.prospect.organizationInfo.addressDetails.country = UAE;
      newConfig.prospect.organizationInfo.addressDetails.preferredAddress = "Y";
    }

    if (newConfig.roProspect) {
      newConfig.roProspect.signatoryInfo = [];
    }

    if (signatoryModel) {
      yield put(saveSignatoryModel(signatoryModel));
    }
    if (roSignatoryModel) {
      yield put(saveRoSignatoryModel(roSignatoryModel));
    }

    yield put(receiveAppConfigSuccess(newConfig));
    yield put(sendProspectToAPISuccess());
  } catch (error) {
    log(error);
    yield put(receiveAppConfigFail(error));
  }
}

export function* updateProspectSaga(action) {
  const state = yield select();
  const prospect = cloneDeep(getProspect(state));
  const newConfig = {
    ...state.appConfig,
    prospect
  };

  for (let name in action.payload) {
    set(newConfig, name, action.payload[name]);
  }

  yield put(setConfig(newConfig));
}

export function* updateRoProspectSaga(action) {
  const state = yield select();
  const roProspect = cloneDeep(getRoProspect(state));
  const newConfig = {
    ...state.appConfig,
    roProspect
  };

  for (let name in action.payload) {
    set(newConfig, name, action.payload[name]);
  }

  yield put(setConfig(newConfig));
}

export function* updateViewIdSaga({ payload: { viewId, isSendToApi, isRoFlow } }) {
  yield put(updateProspect({ "prospect.applicationInfo.viewId": viewId }));
  if (isSendToApi) {
    yield put(sendProspectToAPI(AUTO));
  }
  if (isRoFlow) yield put(updateRoProspect({ "roProspect.applicationInfo.viewId": viewId }));
}

export function* updateConsentEmailTimeSaga({ payload: { consentEmailTriggerTime, isSendToApi } }) {
  yield put(
    updateProspect({ "prospect.applicationInfo.consentEmailTriggerTime": consentEmailTriggerTime })
  );
  if (isSendToApi) {
    yield put(sendProspectToAPI(AUTO));
  }
}
export function* receiveDatalistSearchSaga({ payload: { codeType, searchPattern } }) {
  try {
    const state = yield select();
    const headers = getAuthorizationHeader(state);
    const response = yield call(getDatalistSearch.get, headers, codeType, searchPattern);

    yield put(receiveDatalistSearchSuccess(response.data));
  } catch (error) {
    log(error);
    yield put(receiveDatalistSearchFail(error));
  }
}

export default function* appConfigSaga() {
  yield all([
    takeLatest(RECEIVE_APPCONFIG, receiveAppConfigSaga),
    takeLatest(UPDATE_PROSPECT, updateProspectSaga),
    takeLatest(UPDATE_ROPROSPECT, updateRoProspectSaga),
    takeLatest(UPDATE_VIEW_ID, updateViewIdSaga),
    takeLatest(UPDATE_CONSENT_EMAIL_TRIGGER_TIME, updateConsentEmailTimeSaga),
    takeLatest(RECEIVE_DATALIST_SEARCH, receiveDatalistSearchSaga)
  ]);
}
